export enum IMAGE_MODE {
    POPUP = 'POPUP',
    SLIDESHOW = 'SLIDESHOW',
    SWIPER = 'SWIPER',
    ZOOMIN = 'ZOOMIN',
}
